module.exports = __webpack_public_path__ + "catalog/items/kitchen/logo.jpg";